var map = {
	"./tcp.de_DE.json": [
		3135,
		"src_assets_i18n_tcp_de_DE_json"
	],
	"./tcp.en_GB.json": [
		434,
		"src_assets_i18n_tcp_en_GB_json"
	],
	"./tigerking.de_DE.json": [
		6304,
		"src_assets_i18n_tigerking_de_DE_json"
	],
	"./tigerking.en_GB.json": [
		5504,
		"src_assets_i18n_tigerking_en_GB_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6297;
module.exports = webpackAsyncContext;